import { PDFViewer } from 'ComponentLibrary'
import { useState } from 'react'
import { FooterLocale, getFooterCopy, useFooterLocale } from 'ComponentLibrary/src/molecules/Footer/footerCopy'

type PrivacyPolicyProps = {
    isPrivacyPolicyOpen: boolean
    setIsPrivacyPolicyOpen?: (open: boolean) => void
    locale?: FooterLocale
}

export const PrivacyPolicy = ({ isPrivacyPolicyOpen, setIsPrivacyPolicyOpen, locale }: PrivacyPolicyProps) => {
    const [privacyPolicyPageNumber, setPrivacyPolicyPageNumber] = useState(1)
    const resolvedLocale = useFooterLocale(locale)
    const copy = getFooterCopy(resolvedLocale)

    return (
        <PDFViewer
            file={resolvedLocale === 'en-US' ? '/privacy_policy.pdf' : '/datenschutz.pdf'}
            open={isPrivacyPolicyOpen}
            setOpen={setIsPrivacyPolicyOpen}
            fileName={copy.privacyPolicyModal.title}
            downloadLabel={copy.privacyPolicyModal.download}
            pageNumber={privacyPolicyPageNumber}
            setPageNumber={setPrivacyPolicyPageNumber}
        />
    )
}
